import React from "react";
import ModalForm from "./ModalForm";
import Select from "react-select";
import {FaCameraRetro} from "react-icons/fa";
import BarcodeScannerComponent from "../BarcodeScannerComponent";
import {sweetalert} from "../../App";
import DatePicker from 'react-datepicker'
import moment from "moment";
import TestType from "../../types/TestType";
import { handleTestsForWalkinAndCheckin, handleSpecimenIDsOrLots, parseDate, getNameFromID} from "../../util/FormatUtil";
import { isBlank, isOnlyWhitespace } from "../../util/ValidationUtil";

export interface ChangeVals{
    FirstName?:string
    LastName?:string
    DOB?:string
    SpecimenID?:string
    SpecimenSourceID?
    Lot?
    TestIDs?
    ServiceID?
}


interface CheckinProps{
    onSubmit
    tests?:TestType[]
    sources?
    services?
    selectedSample
    pod?
}
interface CheckinModalState{
    showScanner?:boolean
    selectedSample?
    selectedSpecimenSource?
    selectedTests?
    selectedTestLabels?
    serviceSpecificTests?
    podServices?
    serviceID?
}
class CheckinPatientModal extends React.Component<CheckinProps, CheckinModalState>{
    public formRef: React.RefObject<ModalForm>;

    constructor(props) {
        super(props);
        this.state ={showScanner:false}
        this.formRef = React.createRef()
        this.handleScan = this.handleScan.bind(this);
    }

    componentWillReceiveProps(nextProps: Readonly<CheckinProps>, nextContext: any) {

        this.setState({
            selectedSample:{
                ID: nextProps.selectedSample ? nextProps.selectedSample.ID : null,
                LinkedApptsID: nextProps.selectedSample ? nextProps.selectedSample.LinkedApptsID : null,
                SpecimenID: nextProps.selectedSample ? nextProps.selectedSample.SpecimenID : null,
                PatientFirstName: nextProps.selectedSample ? nextProps.selectedSample.PatientFirstName : null,
                PatientLastName: nextProps.selectedSample ? nextProps.selectedSample.PatientLastName : null,
                PatientDOB: nextProps.selectedSample ? parseDate(nextProps.selectedSample?.PatientDOB) : null,
                ServiceID: nextProps.selectedSample ? nextProps.selectedSample.ServiceID : null,
                TestIDs: nextProps.selectedSample && nextProps.selectedSample.TestIDs ? JSON.parse(nextProps.selectedSample.TestIDs) : null,
                Lot: nextProps.selectedSample && nextProps.selectedSample.Lot ? nextProps.selectedSample.Lot : null,
                Memo: nextProps.selectedSample && nextProps.selectedSample.Memo ? nextProps.selectedSample.Memo : null,
                SpecimenSourceID: nextProps.selectedSample && nextProps.selectedSample.SpecimenSourceID ? nextProps.selectedSample.SpecimenSourceID : null,
            }  
        })
    }

    public static display(){
        window["$"]("#" + CheckinPatientModal.ID).modal('show');
        setTimeout(() =>{
            $("#SpecimenID").triggerHandler( "focus" );
        }, 500)
    }

    componentDidMount(): void {
        window["$"]("#" + CheckinPatientModal.ID).on('shown.bs.modal', function () {
         $('#SpecimenID').triggerHandler( "focus" );
        })
    }

    showBarcodeScanner = (e) => {
        this.setState({showScanner: true})
    }

    handleScan(scan, selectedTest) {
        if (!scan) {
            this.setState({showScanner: false});
            return;
        }
        sweetalert.fire({
            title: "Scan Captured",
            html: "Please verify <b> " + scan.text + " </b>  matches the barcode.",
            icon: "info",
            showCancelButton: true,
            allowOutsideClick: false,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState((prevState) => ({
                    showScanner: false,
                    selectedSample: {
                        ...prevState.selectedSample,
                        SpecimenID: scan.text
                    }
                }))
            }
            if (result.isDismissed) {
                //keep scanner div open so user can hit Scan
                this.setState({showScanner: true})
            }
        });
    }
    

    public static readonly ID = "checkin"
    render(): React.ReactElement | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

        // console.log('CheckinPatientModal props ', this.props)
        // console.log('CheckinPatientModal state ', this.state)

        let service = this.state.selectedSample?.ServiceID ? this.props.services.find(s => s.ID === this.state.selectedSample.ServiceID) : null
        let specIDString = service && service.IsLabService ? "Specimen ID" : "Specimen ID (optional)"
        let hasLabTest = service && service.IsLabService ? true : false


        //get pod services and make dropdown labels
        let podServiceIDs = this.props.pod ? JSON.parse(this.props.pod.value.ServiceIDs) : [];
        let podServies = [];
        if(podServiceIDs.length > 0){
            for (let i = 0; i < this.props.services.length; i++) {
                for (let j = 0; j < podServiceIDs.length; j++) {
                    if(this.props.services[i].ID === podServiceIDs[j]){
                        podServies.push(this.props.services[i])
                    }
                }
            }
        }

        //get selected service (can only be one) and display this one
        let selectedPodService = podServies.find(p => p.ID === this.state.selectedSample?.ServiceID)
        let multiTestAllow = false
        if(selectedPodService){
            multiTestAllow = selectedPodService.AllowMultipleTests ? true : false;
        }

        let selectedPodServiceLabel;
        let serviceAssociatedTests = [];
        let serviceAssociatedTestsLabels = [];
        if(selectedPodService){
            selectedPodServiceLabel = {label: selectedPodService.Name, value: selectedPodService.ID}

            //get tests for selected service, make dropdown labels, and display in dropdown
            if(selectedPodService.Tests){
                for (let i = 0; i < selectedPodService.Tests.length; i++) {
                    for (let j = 0; j < this.props.tests.length; j++) {
                        if(selectedPodService.Tests[i] === this.props.tests[j].ID){
                            serviceAssociatedTests.push(this.props.tests[j])
                            serviceAssociatedTestsLabels.push({label: this.props.tests[j].Name, value: this.props.tests[j].ID})
                        }
                    }
                } 
            }
        }


        //update shown tests labels
        let testLabels = []
        let selectedTests = []

        if(this.state.selectedSample && this.state.selectedSample.TestID){
            let temp = this.props.tests.filter(t => t.ID === this.state.selectedSample.TestID)
            selectedTests = selectedTests.concat(temp)
        }
        else if(this.state.selectedSample?.TestIDs?.length > 0 && this.props.tests.length > 0){
            if(multiTestAllow){
                for (let i = 0; i < this.props.tests.length; i++) {
                    for (let j = 0; j < this.state.selectedSample.TestIDs.length; j++) {
                        if(this.props.tests[i].ID === this.state.selectedSample.TestIDs[j]){
                            testLabels.push({label: this.props.tests[i].Name, value: this.props.tests[i].ID})
                            selectedTests.push(this.props.tests[i])
                        }
                    }
                }
            }
            else{
                let temp = this.props.tests.filter(t => t.ID === this.state.selectedSample.TestIDs[0])
                testLabels.push({label: temp[0].Name, value: temp[0].ID})
                selectedTests = selectedTests.concat(temp)
            }
            
        }


        let selectedTestsSpecimenSourcesLabels = [];
        let selectedSpecimenSourceLabel;
        if(selectedTests?.length > 0){
            let shortestObj = selectedTests.reduce((min_obj, obj) => min_obj.ValidSpecimenSources.length < obj.ValidSpecimenSources.length ? min_obj : obj)


            shortestObj.ValidSpecimenSources.map(vss => {
                selectedTestsSpecimenSourcesLabels.push({label: vss.Name, value: vss.ID})
            })

            selectedSpecimenSourceLabel = this.props.sources.map(s => {
                if(s.ID === this.state.selectedSample.SpecimenSourceID){
                    return {label: s.Name, value: s.ID}
                }
            })
        }
        
        return (
            <div className="modal fade form_modal" id={CheckinPatientModal.ID} tabIndex={-1} role="dialog"
                 aria-labelledby="result_modal_label"
                 aria-hidden="true">
                <div className="modal-dialog modal-lg modal-xl" role="document">
                    <div className="modal-content">
                    <div className="container-fluid">
                        <div className="modal-header">
                            <h5 className="modal-title" id="result_modal_label">Patient Check-in
                            </h5>
                            <button style={{outline: 'none'}}  type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body mr-3">
                            <div className="form-group row">
                                <label htmlFor={"FirstName"} className={"col-sm-4 col-form-label"}>First Name</label>
                                <div className={"col-sm-8 p-0 m-0"} id={"FirstName"}>
                                    <input type={"search"} className="form-control" readOnly={false} id={"FirstName"}
                                           value={this.state.selectedSample?.PatientFirstName}
                                           autoComplete="off"
                                           onChange={(e) => 
                                                this.setState((prevState) => ({
                                                    selectedSample: {
                                                        ...prevState.selectedSample,
                                                        PatientFirstName: e.target.value
                                                    }
                                                }))
                                            }
                                           maxLength={50}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor={"LastName"} className={"col-sm-4 col-form-label"}>Last Name</label>
                                <div className={"col-sm-8 p-0 m-0"} id={"LastName"}>
                                    <input type={"search"} className="form-control" readOnly={false} id={"LastName"}
                                           value={this.state.selectedSample?.PatientLastName}
                                           autoComplete="off"
                                           onChange={(e) => 
                                            this.setState((prevState) => ({
                                                selectedSample: {
                                                    ...prevState.selectedSample,
                                                    PatientLastName: e.target.value
                                                }
                                            }))
                                        }
                                           maxLength={50}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor={"DOB"} className={"col-sm-4 col-form-label"}>DOB</label>
                                <div className={"col-sm-8 p-0 m-0"} id={"DOB"}>

                                    <DatePicker
                                        minDate={new Date('01-01-1000')}
                                        maxDate={new Date('12-31-9999')}
                                        placeholderText="--/--/----"
                                        selected={Date.parse(moment(this.state.selectedSample?.PatientDOB, 'MM-DD-YYYY').toISOString())}
                                        onChange={(e) => 
                                            this.setState((prevState) => ({
                                                selectedSample: {
                                                    ...prevState.selectedSample,
                                                    PatientDOB: e
                                                }
                                            }))
                                        }
                                    />

                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor={"TestType"} className={ "col-sm-4 col-form-label"}>Service</label>
                                <div className={"col-sm-8 p-0 m-0 "} id={"Service"}>

                                    <Select
                                        isSearchable={true}
                                        placeholder={"Please Select..."}
                                        noOptionsMessage={() => "No option"}
                                        value={selectedPodServiceLabel}
                                        onChange={(e) => 
                                            this.setState((prevState) => ({
                                                selectedSample: {
                                                    ...prevState.selectedSample,
                                                    ServiceID: e.value,
                                                    TestIDs: null
                                                }
                                            }))
                                        }
                                        className={"state_select"}
                                        options={podServies.map(t => ({label:t.Name, value:t.ID}))}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor={"TestType"} className={ "col-sm-4 col-form-label"}>{selectedTests?.length > 1 ? 'Tests' : 'Test'}</label>
                                <div className={"col-sm-8 p-0 m-0 "} id={"TestType"}>

                                    <Select
                                        isMulti={!this.state.selectedSample?.TestID && multiTestAllow}
                                        isSearchable={true}
                                        placeholder={"Please Select..."}
                                        noOptionsMessage={() => "No option"}
                                        value={this.state.selectedSample?.TestID ? {label: getNameFromID(this.state.selectedSample.TestID, this.props.tests), value: this.state.selectedSample.TestID}: testLabels}
                                        onChange={(e) => {
                                            let testIDs = [];
                                            if(!e){
                                                testIDs = []
                                            }
                                            else if(Array.isArray(e)){
                                                e.map(b => {
                                                    testIDs.push(b.value)
                                                })
                                            }
                                            else{
                                                testIDs.push(e.value)
                                            }
                                            this.setState((prevState) => ({
                                                selectedSample: {
                                                    ...prevState.selectedSample,
                                                    TestIDs: testIDs,
                                                    SpecimenSourceID: null
                                                }
                                                
                                            }))
                                        }}
                                        className={"state_select"}
                                        options={serviceAssociatedTestsLabels}
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label htmlFor={"SpecimenID"} className={"col-sm-4 col-form-label"}>{specIDString}</label>
                                <div className={"col-sm-8 p-0 m-0 input-group"}>
                                    <button className={"btn btn-primary btn-sm"}
                                            onClick={this.showBarcodeScanner}
                                            disabled={!this.state.selectedSample?.TestIDs || this.state.selectedSample?.TestIDs?.length < 1}
                                    ><FaCameraRetro/></button>
                                    <input type={"search"} className="form-control" readOnly={false} id={"SpecimenID"}
                                           value={this.state.selectedSample?.SpecimenID}
                                           autoComplete="off"
                                           onChange={(e) => {
                                            this.setState((prevState) => ({
                                                selectedSample: {
                                                    ...prevState.selectedSample,
                                                    SpecimenID: e.target.value,
                                                }
                                                }))
                                            }}
                                           disabled={!this.state.selectedSample?.TestIDs || this.state.selectedSample?.TestIDs?.length < 1}
                                           maxLength={50}
                                    />
                                </div>
                            </div>
                            { this.state.showScanner ?
                                <BarcodeScannerComponent
                                    onResult={this.handleScan}
                                    showButtons={true}
                                    started={false}
                                />
                                : null
                            }

                            <div className="form-group row">
                                <label htmlFor={"Lot"} className={"col-sm-4 col-form-label"}>Lot (optional)</label>
                                <div className={"col-sm-8 p-0 m-0"} id={"Lot"}>
                                    <input type={"search"} className="form-control" readOnly={false} id={"Lot"}
                                            disabled={!this.state.selectedSample?.TestIDs || this.state.selectedSample?.TestIDs?.length < 1}
                                           value={this.state.selectedSample?.Lot}
                                           autoComplete="off"
                                           onChange={(e) => {
                                            this.setState((prevState) => ({
                                                selectedSample: {
                                                    ...prevState.selectedSample,
                                                    Lot: e.target.value,
                                                }
                                                }))
                                            }} 
                                           maxLength={45}
                                    />
                                </div>
                            </div>

                            
                            <div className="form-group row">
                                <label htmlFor={"Specimen Source"} className={ "col-sm-4 col-form-label"}>Specimen Source</label>
                                <div className={"col-sm-8 p-0 m-0 "} id={"Specimen Source"}>
                                    <Select
                                        placeholder={"Please Select..."}
                                        value={this.state.selectedSample?.SpecimenSourceID ? {label: getNameFromID(this.state.selectedSample.SpecimenSourceID, this.props.sources), value: this.state.selectedSample.SpecimenSourceID} : selectedSpecimenSourceLabel}
                                        onChange={(e) => {
                                            this.setState((prevState) => ({
                                                selectedSample: {
                                                    ...prevState.selectedSample,
                                                    SpecimenSourceID: e.value
                                                }
                                            }))
                                        }}
                                        className={"state_select"}
                                        isDisabled={!this.state.selectedSample?.TestIDs || this.state.selectedSample?.TestIDs?.length < 1}
                                        options={selectedTestsSpecimenSourcesLabels}
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label htmlFor={"Memo"} className={"col-sm-4 col-form-label pb-0"}>
                                    <p className="mb-0">Memo (optional)</p>
                                </label>
                                <div className={"col-sm-8 p-0 m-0 "}>
                                    <textarea
                                        id={"Memo"}
                                        rows={3}
                                        maxLength={1000}
                                        className={'form-control'}
                                        value={this.state.selectedSample?.Memo}
                                        autoComplete="off"
                                        onChange={(e) => {
                                            this.setState((prevState)=>({
                                                selectedSample: {
                                                ...prevState.selectedSample,
                                                Memo: e.target.value
                                                }
                                            })
                                        )}
                                        }

                                    />
                                    <div className={this.state.selectedSample?.Memo && this.state.selectedSample?.Memo.length > 0 ? 'visible float-right' : 'invisible'}>
                                        <div style={{fontSize: '0.8em'}}>{this.state.selectedSample?.Memo && this.state.selectedSample.Memo?.length}/1000</div>
                                    </div>
                                </div>
                            </div>
                                                                
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" 
                                    onClick={() => {
                                        let editedSample = JSON.parse(JSON.stringify(this.state.selectedSample))
                                        if(hasLabTest && (isBlank(this.state.selectedSample.SpecimenID) || isOnlyWhitespace(this.state.selectedSample.SpecimenID))){
                                            return sweetalert.fire({icon: "error", title: "", text: `Specimen ID is required`});
                                        }
                                        this.props.onSubmit(editedSample)
                                    }}
                                >
                                    Submit
                                </button>
                            </div>
                        
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default CheckinPatientModal;